/**
 * Check date is valid and real (e.g. catches 31/2/2020) 
 */
export function isDateValid(date, day, month, year) {
    return date instanceof Date
        && date.getDate() === day
        && date.getMonth() === month - 1
        && date.getFullYear() === year;
}